import { IPack, IPackQuestion } from '@/contracts/modules/education/entities/IPack'
import { IAnswered, IPackInfo, IPackQuestionRecord } from '@/contracts/modules/education/entities/IPackRecord'
import { IQuestionData } from '@/contracts/modules/education/entities/IQuestionData'
import { EnumWeight } from '@/contracts/modules/education/enum/EnumWeight'

export class PackQuestion implements IPackQuestion {
  /** data — null: ключ или данные не расшифровались, вопрос в опросе пропускается */
  constructor(private record: IPackQuestionRecord, private data: IQuestionData | null) {}

  getUuid(): string {
    return this.record.uuid
  }

  getNode(): string {
    return this.record.node
  }

  getWeight(): EnumWeight {
    return this.record.weight as EnumWeight
  }

  getQuestion(): string {
    return this.data?.question ?? ''
  }

  getAnswer(): string {
    return this.data?.answer ?? ''
  }

  getAnswered(): IAnswered | null {
    return this.record.answered
  }

  isUnreadable(): boolean {
    return this.data === null
  }
}

export class Pack implements IPack {
  constructor(private info: IPackInfo, private questions: PackQuestion[]) {}

  getUuid(): string {
    return this.info.uuid
  }

  getCreatedAt(): string {
    return this.info.createdAt
  }

  getExpiresAt(): string {
    return this.info.expiresAt
  }

  getPeriod(): number {
    return this.info.period
  }

  getSize(): number {
    return this.info.size
  }

  getQuestions(): PackQuestion[] {
    return this.questions
  }
}
